'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var ModalContext = require('./ModalContext.js');
var reactI18next = require('react-i18next');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var constants$1 = require('../../constants.js');
var constants = require('./constants.js');
var modal_module = require('./modal.module.scss.js');
var ChevronLeftIcon = require('../alloy-icon/ChevronLeftIcon.js');

var ModalPage = function (_a) {
    var backButtonClassName = _a.backButtonClassName, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.focusSelector, focusSelector = _c === void 0 ? '' : _c, isActiveModal = _a.isActiveModal, isChildModal = _a.isChildModal, isTransitioning = _a.isTransitioning, onClose = _a.onClose, onOpen = _a.onOpen, previousPage = _a.previousPage, suppressPadding = _a.suppressPadding;
    var _d = react.useState(''), transition = _d[0], setTransition = _d[1];
    var _e = react.useState(), initialFocused = _e[0], setInitialFocused = _e[1];
    var _f = react.useContext(ModalContext.default), removeCurrentModal = _f.removeCurrentModal, hideLoader = _f.hideLoader;
    var t = reactI18next.useTranslation()[0];
    var pageRef = react.useRef(null);
    var handleBackButtonClick = function () {
        setTransition('slideout');
        removeCurrentModal(500);
        hideLoader();
    };
    var getBackToText = function (title) {
        return t('GENERAL_BACK_TO').replace('{0}', title);
    };
    var getBackButton = function () { return (jsxRuntime.jsx("div", { children: jsxRuntime.jsxs(AlloyButton.AlloyButton, tslib.__assign({ buttonType: "ghost", "aria-label": t('GOBACK'), addClass: backButtonClassName
                ? backButtonClassName
                : modal_module.default['child__back-button'], onClick: handleBackButtonClick }, { children: [jsxRuntime.jsx(ChevronLeftIcon.default, { className: "".concat(modal_module.default['fill-gray']), height: 20, width: 20 }), jsxRuntime.jsx("span", tslib.__assign({ className: "".concat('back-button') }, { children: previousPage ? getBackToText(previousPage) : t('GOBACK') }))] })) })); };
    var getPadding = function (isChildModalParam) {
        return isChildModalParam
            ? 'px-3 ps-lg-3 pe-lg-0 pb-lg-0 pb-3'
            : "".concat(modal_module.default['modal__page--parent-content'], " px-3 px-lg-0 ");
    };
    react.useEffect(function () {
        if (initialFocused && !isActiveModal) {
            initialFocused.blur();
            setInitialFocused(null);
        }
    }, [initialFocused, isActiveModal]);
    react.useEffect(function () {
        if (isActiveModal && (!isTransitioning || !isChildModal)) {
            // focus on provided element then fallback to interactive components then finally close button
            var selector = focusSelector ? focusSelector : constants$1.ALL_FOCUSABLE_SELECTOR;
            var container = (pageRef === null || pageRef === void 0 ? void 0 : pageRef.current) || document;
            var focusableContent = container.querySelectorAll(selector);
            var focusable = focusableContent[0];
            if (focusable === null || focusable === void 0 ? void 0 : focusable.classList.contains('child__back-button')) {
                focusable = focusableContent[1];
            }
            focusable =
                focusable || document.querySelectorAll(constants.DEFAULT_FOCUS_SELECTOR)[0];
            setInitialFocused(focusable);
            if (focusable && focusable.focus) {
                focusable.focus();
            }
        }
    }, [focusSelector, isActiveModal, isChildModal, isTransitioning]);
    react.useEffect(function () {
        if (isActiveModal) {
            setTransition('slidein');
        }
    }, [isActiveModal]);
    react.useEffect(function () {
        var cleanup = function () {
            if (onClose) {
                onClose();
            }
        };
        if (onOpen) {
            onOpen();
        }
        return cleanup;
    }, [onOpen, onClose]);
    // Hide loader when un-mounting the modal page to avoid letting the state in true
    react.useEffect(function () { return function () { return hideLoader(); }; }, [hideLoader]);
    return (jsxRuntime.jsx("div", tslib.__assign({ className: "".concat(className, " ").concat(modal_module.default['modal__page'], " ").concat(isChildModal ? "".concat(modal_module.default['child'], " ").concat(modal_module.default[transition]) : ''), "data-testid": "modalTransition", ref: pageRef }, { children: jsxRuntime.jsxs("div", tslib.__assign({ className: "".concat(suppressPadding ? '' : getPadding(isChildModal), " d-flex flex-column-reverse") }, { children: [jsxRuntime.jsx("div", { children: children && children }), isChildModal && getBackButton()] })) })));
};
var ModalPage$1 = ModalPage;

exports.default = ModalPage$1;
//# sourceMappingURL=ModalPage.js.map
